import React, { useContext } from 'react'
import { validateSteps } from 'app/React/Helpers/StepHelper'
import { ConfiguratorContext } from "app/React/ConfiguratorContainer";

export default function PaymentTerms(props) {
  const {
    currentVariant,
    isDealerConfigurator,
    order,
    strings,
    setOrder,
    setValidSteps
  } = useContext(ConfiguratorContext)

  const paymentFormStrings = strings.payment_form ?? {}
  const showTextAbovePaymentTerms = typeof paymentFormStrings?.text_above_payment_terms?.description === 'string' &&
    paymentFormStrings?.text_above_payment_terms?.description.length > 0
  const showPaymentTerms = Boolean(Number(currentVariant?.steps?.[5]?.show_payment_terms ?? '0'))
  const paymentType = order.paymentType ?? 'cash'

  const onChange = function (e) {
    const currentVariantSteps = currentVariant.steps ?? {}

    order.payment_terms_accepted = e.currentTarget.checked
    setOrder({ ...order })
    setValidSteps(validateSteps(currentVariantSteps, order, isDealerConfigurator, currentVariant))
  }

  const textAbovePaymentTerms = () => {
    if (paymentType === 'leasing') {
      let text = paymentFormStrings.text_above_payment_terms.hasOwnProperty('leasing_description')
        ? paymentFormStrings.text_above_payment_terms.leasing_description
        : paymentFormStrings.text_above_payment_terms.description

      return text.replace('{{variant_leasing_company}}', currentVariant.leasing_company_name)
    }

    return paymentFormStrings.text_above_payment_terms.hasOwnProperty('cash_description')
      ? paymentFormStrings.text_above_payment_terms.cash_description
      : paymentFormStrings.text_above_payment_terms.description
  }

  if (!showTextAbovePaymentTerms && !showPaymentTerms) {
    return null
  }

  return (
    <>
      {
        showTextAbovePaymentTerms && (
          <>
            <div className='config-form__description'
              dangerouslySetInnerHTML={{ __html: textAbovePaymentTerms() }} />

            <div className='config-form__separator'/>
          </>
        )
      }

      {
        showPaymentTerms && (
          <>
            <h2 className='config-form__subtitle'>
              {paymentFormStrings.payment_terms.label}
              <div className='config-tooltip'/>
            </h2>

            <div className='config-checkbox'>
              <label htmlFor='consent'>
                <input type='checkbox' name='consent' id='consent' onChange={onChange}/>
                <div dangerouslySetInnerHTML={{ __html: paymentFormStrings.payment_terms.description }}/>
              </label>
            </div>

            <div className='config-form__separator'/>
          </>
        )
      }
    </>
  )
}
